import { render, staticRenderFns } from "./FormTextAreaStates.vue?vue&type=template&id=346a213d"
import script from "./FormTextAreaStates.vue?vue&type=script&lang=js"
export * from "./FormTextAreaStates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports